import React, { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { c as classnames } from './index-2586sEvh.js';
import { b as getTabsLabel } from './helper-RkQGS-Ry.js';
import { S as ScrollToPluginExports } from './ScrollToPlugin-k_fMCFg8.js';
import { g as gsapWithCSS } from './index-RkBJ48Nr.js';
import { useRouter } from 'next/router';

const ItemsAccordion = ({ items, setActiveTab, activeTab, accordionExtraContent, }) => {
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const tabsRef = useRef(null);
    const router = useRouter();
    const ctx = gsapWithCSS.context(self => {
        gsapWithCSS.registerPlugin(ScrollToPluginExports.ScrollToPlugin);
        const duration = 0.3;
        self.add('onLoad', (activeEl) => {
            gsapWithCSS.set(activeEl, {
                height: 'auto',
            });
        });
        self.add('reset', (targetEl) => {
            gsapWithCSS.set(targetEl, {
                height: 0,
            });
        });
        self.add('onClose', (targetEl) => {
            gsapWithCSS.to(targetEl, {
                duration,
                height: 0,
                ease: 'sine.inOut',
            });
        });
        self.add('onOpen', (targetEl) => {
            gsapWithCSS.to(targetEl, {
                duration,
                height: 'auto',
                ease: 'sine.inOut',
            });
        });
        self.add('handleScroll', (targetEl, currentEl) => {
            const height = targetEl.scrollHeight;
            const prevHeight = currentEl.scrollHeight;
            const tabsNode = tabsRef.current;
            const rect = tabsNode.getBoundingClientRect();
            if (rect.top < 0) {
                gsapWithCSS.to(window, {
                    duration,
                    scrollTo: window.scrollY - prevHeight + height,
                    ease: 'sine.inOut',
                });
            }
        });
    });
    useEffect(() => {
        setTimeout(() => {
            if (!tabsRef.current) {
                return;
            }
            const active = tabsRef.current.querySelector('.accordion-panel-wrapper.active');
            const inActive = tabsRef.current.querySelectorAll('.accordion-panel-wrapper:not(.active)');
            if (inActive) {
                inActive.forEach((el) => ctx.reset(el));
            }
            ctx.onLoad(active);
        }, 150);
        return () => ctx.revert();
    }, [router]);
    useEffect(() => {
        const panels = tabsRef.current.querySelectorAll('.accordion-panel');
        panels.forEach((element) => {
            const div = element;
            if (div) {
                div.scrollTop = 0;
            }
        });
    }, [router]);
    const handleAccordionClick = (toTabName) => {
        const currentTab = tabsRef.current.querySelector('.accordion-panel-wrapper.active');
        const nextTab = tabsRef.current.querySelector(`#panel-${toTabName + 1}`);
        const nextTabParent = nextTab.parentNode;
        if (!currentTab) {
            ctx.onOpen(nextTabParent);
            setActiveTab(toTabName);
            return;
        }
        if (currentTab === nextTabParent) {
            ctx.onClose(currentTab);
            setActiveTab(null);
            return;
        }
        ctx.onClose(currentTab);
        ctx.onOpen(nextTabParent);
        // for more than 2 elements there are cases where you can end up at the end of the page depending on the accordion height and your scroll postion
        if (items.length > 2) {
            ctx.handleScroll(nextTabParent, currentTab);
        }
        setActiveTab(toTabName);
    };
    return (React.createElement("div", { className: "item-copy-container" },
        accordionExtraContent && (React.createElement("div", { className: "accordion-extra-content", dangerouslySetInnerHTML: {
                __html: accordionExtraContent,
            } })),
        React.createElement("div", { className: "item-copy clear", ref: tabsRef }, items.map((item) => (React.createElement("div", { key: item.type, className: "item-wrapper" },
            React.createElement("button", { type: "button", id: `item-${item.type + 1}`, className: classnames('accordion-button', { active: activeTab === item.type }), onClick: () => handleAccordionClick(item.type), "aria-expanded": activeTab === item.type, "aria-controls": `panel-${item.type + 1}`, "data-event-name": "bloc_interact", "data-bloc-name": tLabel(getTabsLabel(item.type)) },
                React.createElement("span", null, tLabel(getTabsLabel(item.type))),
                React.createElement("span", { className: "icon-right-arrow" })),
            React.createElement("div", { className: classnames('accordion-panel-wrapper', {
                    active: activeTab === item.type,
                }) },
                React.createElement("div", { className: "accordion-panel", dangerouslySetInnerHTML: { __html: item.html }, id: `panel-${item.type + 1}`, "aria-labelledby": `item-${item.type + 1}`, role: "tabpanel", tabIndex: 0 }))))))));
};

export { ItemsAccordion as I };
//# sourceMappingURL=ItemsAccordion-_99u1-cH.js.map
